import { useTableManagerContext } from "@/providers/AppendTableProvider";
import { GetWSMgr } from "@/Utils/StateLib";
import { useAppendTableManagement } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/DataSources/AppendTable/useAppendTableManagement";
import CentralizedModalContainer from "@/appComponents/Blocks/Utils/CentralizedModalContainer/CentralizedModalContainer";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Flex,
  Icon,
  Input,
  Modal
} from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";
import { DATA_SOURCES_TEST_PREFIX } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/Utils";
import * as React from "react";
import { useEffect, useRef, useState } from "react";

export const CreateAppendTableModal = () => {
  const wsMgr = GetWSMgr();
  const { handleCreateTable, getDefaultNewTableName, validateTableName } =
    useAppendTableManagement(wsMgr);
  const { showCreateAppendTableModal, setShowCreateAppendTableModal } = useTableManagerContext();
  const [customTableName, setCustomTableName] = React.useState("");
  const [defaultTableName, setDefaultTableName] = React.useState("");
  const [validation, setValidation] = useState({ status: "default", errorMsg: "", isValid: true });

  const inputRef = useRef(null);

  useEffect(() => {
    const startingName = getDefaultNewTableName();
    setCustomTableName(startingName);
    setDefaultTableName(startingName);
    setValidation({ status: "default", errorMsg: "", isValid: true });
    handleAutoInputSelect();
  }, [showCreateAppendTableModal]);

  const handleNext = () => {
    const valid = handleCreateTable(customTableName);
    setValidation(valid);
    setShowCreateAppendTableModal(!valid.isValid);
  };

  const handleCancel = () => {
    setShowCreateAppendTableModal(false);
  };

  const handleInputChange = e => {
    const newName = e.target.value;
    setCustomTableName(newName);
    setValidation(validateTableName(newName));
  };

  const handleAutoInputSelect = () => {
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
        inputRef.current.select();
      }
    }, 10);
  };

  return (
    <CentralizedModalContainer show={showCreateAppendTableModal}>
      <Modal
        id={"manage-append-table-modal"}
        dataTestId={`${DATA_SOURCES_TEST_PREFIX}-append-table-create-modal`}
        show={showCreateAppendTableModal}
        onClose={handleCancel}
        minWidth={"large"}
        maxWidth={"large"}
        fullScreen={true}
        withShadow={true}
        centerScreen={true}
      >
        <DialogTitle
          divider={true}
          onClose={handleCancel}
          data-testid={`${DATA_SOURCES_TEST_PREFIX}-append-table-create-modal-title`}
        >
          <span className={"ocn-explorer-icon-label"}>
            <Icon size={"medium"} name={"table"} />
            {defaultTableName}
          </span>
        </DialogTitle>
        <DialogContent customContentClass={"oc-modal-content-container"}>
          <Flex height={"100%"} direction={"column"} gap={"4px"}>
            <span style={{ paddingTop: "20px" }}>
              <Input
                ref={inputRef}
                require
                onChange={handleInputChange}
                value={customTableName}
                placeholder={defaultTableName}
                dataTestId={"append-table-rename-input"}
                status={validation.status}
                message={validation.errorMsg}
                inputOnly={false}
                size={"medium"}
                label={appstr("Table Name")}
              />
            </span>
          </Flex>
        </DialogContent>
        {
          <DialogActions divider={true}>
            <DialogActions.Tertiary
              onClick={handleCancel}
              dataTestId={"append-table-create-cancel"}
            >
              {appstr("Cancel")}
            </DialogActions.Tertiary>
            <DialogActions.Primary
              onClick={handleNext}
              dataTestId={"append-table-create-next"}
              disabled={!validation.isValid}
              tooltipProps={{ message: validation.errorMsg ?? undefined }}
            >
              {appstr("Next")}
            </DialogActions.Primary>
          </DialogActions>
        }
      </Modal>
    </CentralizedModalContainer>
  );
};
